import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_js_cookie_b8caf806__ from "js-cookie";
import * as __WEBPACK_EXTERNAL_MODULE__nestle_npus_nbm_purina_auth_11a881f8__ from "@nestle-npus-nbm/purina-auth";
import * as __WEBPACK_EXTERNAL_MODULE__common_constants_mjs_a3e5b4c2__ from "../common/constants.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__common_functions_mjs_2dee6bf1__ from "../common/functions.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__components_Dialog_Dialog_mjs_0e0238ef__ from "./components/Dialog/Dialog.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__components_Drawer_Drawer_mjs_69b513e3__ from "./components/Drawer/Drawer.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__components_Drawer_DrawerContents_mjs_1ea241b9__ from "./components/Drawer/DrawerContents.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__components_Spinner_Spinner_mjs_ececbf23__ from "./components/Spinner/Spinner.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__components_UnreadOffers_UnreadOffersBadge_mjs_bbf6bc84__ from "./components/UnreadOffers/UnreadOffersBadge.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__hooks_index_mjs_01b3a980__ from "./hooks/index.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__icons_person_mjs_def0548c__ from "./icons/person.mjs";
const sendLoginAnalytics = async (config, ansiraUuid)=>{
    if (config.analyticsEventHandlers?.handleAuthenticatedEvent) config.analyticsEventHandlers.handleAuthenticatedEvent();
    else {
        (0, __WEBPACK_EXTERNAL_MODULE__common_functions_mjs_2dee6bf1__.sendIt)({
            event: 'form_complete',
            eventParams: {
                form_brand: config.analytics?.formBrand ?? '[not set]',
                form_id: config.analytics?.loginSourceCode ?? 'PUPurinaSiteLogin',
                form_name: 'login',
                form_type: 'login',
                form_parent: config.analytics?.formParent ?? '[not set]',
                form_version: 'v1'
            }
        }, config.pup.dataLayerName, config.pup.logging);
        (0, __WEBPACK_EXTERNAL_MODULE__common_functions_mjs_2dee6bf1__.sendIt)({
            event: 'login',
            eventParams: {
                method: 'PUPurinaSiteRegistration'
            },
            up: {
                user_id: ansiraUuid
            }
        }, config.pup.dataLayerName, config.pup.logging);
    }
};
const setUuidCookie = (ansira_uuid)=>{
    __WEBPACK_EXTERNAL_MODULE_js_cookie_b8caf806__["default"].set('profiles_uuid', ansira_uuid);
    return ansira_uuid;
};
const PurinaProfile = ({ config = __WEBPACK_EXTERNAL_MODULE__common_constants_mjs_a3e5b4c2__.defaultAuth0ProfileConfig, loyaltyPoints, btnLayout = 'horizontal', darkProfileIcon = false, shouldSendLoginAnalytics = true, shouldRedirectOnLogin = true, openLinksInNewTab = false, handleLoginRedirect })=>{
    const { user: userData, isLoading } = (0, __WEBPACK_EXTERNAL_MODULE__hooks_index_mjs_01b3a980__.useGetUser)(config);
    const Auth = __WEBPACK_EXTERNAL_MODULE_react__["default"].useMemo(()=>(0, __WEBPACK_EXTERNAL_MODULE__nestle_npus_nbm_purina_auth_11a881f8__.createAuthClient)(config.auth0), [
        config.auth0
    ]);
    const [user, setUser] = __WEBPACK_EXTERNAL_MODULE_react__["default"].useState();
    const [isOpen, setIsOpen] = __WEBPACK_EXTERNAL_MODULE_react__["default"].useState(false);
    const { unreadOffersCount } = (0, __WEBPACK_EXTERNAL_MODULE__hooks_index_mjs_01b3a980__.useInbox)(config.pup.refreshInboxInterval);
    __WEBPACK_EXTERNAL_MODULE_react__["default"].useEffect(()=>{
        async function exchangeCodeForToken() {
            try {
                const response = await Auth.codeExchangeForToken();
                const { oAuthState } = response || {};
                const { ansira_uuid: ansiraUuid } = await Auth.getCurrentToken('access');
                if (ansiraUuid) {
                    setUuidCookie(ansiraUuid);
                    if (handleLoginRedirect) handleLoginRedirect(ansiraUuid, oAuthState);
                    else {
                        if (shouldSendLoginAnalytics) sendLoginAnalytics(config, ansiraUuid);
                        if (oAuthState?.returnTo && shouldRedirectOnLogin) setTimeout(()=>{
                            const url = new URL(oAuthState.returnTo);
                            url.searchParams.delete('code');
                            url.searchParams.delete('state');
                            window.location.replace(url);
                        }, 100);
                    }
                } else {
                    console.error('ansira_uuid value missing');
                    if (oAuthState?.returnTo && shouldRedirectOnLogin) setTimeout(()=>{
                        const url = new URL(oAuthState.returnTo);
                        url.searchParams.delete('code');
                        url.searchParams.delete('state');
                        window.location.replace(url);
                    }, 100);
                }
            } catch (e) {
                console.error(e);
            }
        }
        const params = new URLSearchParams(window.location.search);
        if (params.get('code')) exchangeCodeForToken();
    }, [
        window.location.search
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__["default"].useEffect(()=>{
        if (userData) setUser({
            name: `${userData.firstName} ${userData.lastName}`,
            points: loyaltyPoints
        });
    }, [
        userData,
        loyaltyPoints
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__["default"].useEffect(()=>{
        if (config.pup.theme) {
            const { primary, primaryAction, primaryActive, text } = config.pup.theme;
            const root = document.querySelector(':root');
            root?.style.setProperty('--ptw-theme-primary', primary);
            root?.style.setProperty('--ptw-theme-primary-action', primaryAction);
            root?.style.setProperty('--ptw-theme-primary-active', primaryActive);
            root?.style.setProperty('--ptw-theme-text', text);
        }
    }, [
        config.pup.theme
    ]);
    const buttonLabelText = ()=>{
        if (false !== isLoading) return 'loading';
        if (user?.name) {
            if (unreadOffersCount > 0) return `${user.name.charAt(0).toUpperCase()} My Account ${unreadOffersCount} Unread messages`;
            return `${user.name.charAt(0).toUpperCase()} My Account`;
        }
        return 'sign in';
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: "purina-profile ptw-font-sans",
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__components_Dialog_Dialog_mjs_0e0238ef__.Dialog, {
            open: isOpen,
            onOpenChange: (e)=>setIsOpen(e),
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__components_Dialog_Dialog_mjs_0e0238ef__.DialogTrigger, {
                    asChild: true,
                    onClick: ()=>{
                        if (config.analyticsEventHandlers?.handleOpenNavEvent) config.analyticsEventHandlers?.handleOpenNavEvent();
                        else (0, __WEBPACK_EXTERNAL_MODULE__common_functions_mjs_2dee6bf1__.sendIt)({
                            event: 'nav_click',
                            eventParams: {
                                nav_item: user ? 'user account' : 'login',
                                nav_type: 'header'
                            }
                        }, config.pup.dataLayerName, config.pup.logging);
                        setIsOpen(true);
                    },
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("button", {
                        className: `${user?.name ? `p-4 ptw-h-[48px] ptw-w-[48px] ptw-rounded-circle ptw-text-title-sm ptw-font-bold ${darkProfileIcon ? 'ptw-bg-secondary-active' : 'ptw-bg-primary-base'}` : 'ptw-bg-secondary-active ptw-p-3'} ptw-flex ptw-cursor-pointer ptw-items-center ptw-justify-center ptw-rounded-pill ptw-border-none ptw-p-4 ptw-font-sans ptw-text-primary-text`,
                        disabled: isLoading,
                        "aria-label": buttonLabelText(),
                        children: user?.name ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                            children: [
                                user.name.charAt(0).toUpperCase(),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__components_UnreadOffers_UnreadOffersBadge_mjs_bbf6bc84__["default"], {
                                    unreadOffersCount: unreadOffersCount
                                })
                            ]
                        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                            className: "ptw-flex ptw-items-center ptw-text-body-md ptw-leading-none",
                            children: false !== isLoading ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__components_Spinner_Spinner_mjs_ececbf23__["default"], {
                                className: "ptw-text-[0px]",
                                size: 24
                            }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__icons_person_mjs_def0548c__["default"], {
                                        fill: "white",
                                        width: 24
                                    }),
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                        className: "ptw-sr-only ptw-ml-2 md:ptw-not-sr-only",
                                        "aria-label": "Sign In",
                                        children: "Sign In"
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__components_Dialog_Dialog_mjs_0e0238ef__.DialogContent, {
                    container: 'undefined' == typeof window ? null : document.body,
                    className: "ptw-fixed ptw-right-4 ptw-top-0 ptw-z-[7001] ptw-mr-[-1rem] ptw-h-[100dvh] ptw-w-full ptw-max-w-[360px] ptw-overflow-y-auto ptw-overflow-x-hidden ptw-bg-[#fff] ptw-font-sans ptw-text-surface-text data-[state=open]:ptw-animate-contentShow",
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        "data-state": isOpen,
                        className: "data-[state=true]:ptw-animate-fadeUp",
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__components_Drawer_Drawer_mjs_69b513e3__.Drawer, {
                            logo: config.pup.logo,
                            altText: config.pup.property,
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__components_Drawer_DrawerContents_mjs_1ea241b9__.DrawerContents, {
                                user: user,
                                config: config,
                                btnLayout: btnLayout,
                                unreadOffersCount: unreadOffersCount,
                                openLinksInNewTab: openLinksInNewTab
                            })
                        })
                    })
                })
            ]
        })
    });
};
PurinaProfile.displayName = 'PurinaProfile';
export { PurinaProfile, sendLoginAnalytics, setUuidCookie };
